import React from 'react';
import Modal from 'react-modal';
import modalUtils from '../../qti/utils/ModalUtils';
import modalStyles from '../../styles/custom/talviewInitAllocatedTimePassedModal.scss';

import { t } from '../../services/i18nService';
import sessionReader from '../../store/readHelpers/SessionReader';

const TalviewInitAllocatedTimePassedModal = () => {
    const assessmentRunId = sessionReader.getAssessmentRunId(true);
    const href = assessmentRunId > 0 ? `/student#list/${assessmentRunId}` : '/student';

    return (<Modal
        isOpen
        role="dialog"
        shouldCloseOnEsc={false}
        shouldCloseOnOverlayClick={false}
        style={modalUtils.confirmationModalStyles}
        tabindex="0"
        aria={{ describedby: 'talviewInitAllocatedTimePassedContent' }}
    >
        <div className={modalStyles.talviewInitAllocatedTimePassedContent} id="talviewInitAllocatedTimePassedContent">
            <h1>{ t('talviewMessage.contactInvigilatorFailMessage.title') }</h1>
            <div>{ t('talviewMessage.contactInvigilatorFailMessage.message1') }</div>
            <div>{ t('talviewMessage.contactInvigilatorFailMessage.message2') }</div>
            <a href={href}>{ t('talviewMessage.contactInvigilatorFailMessage.exit') }</a>
        </div>
    </Modal>);
};

export default TalviewInitAllocatedTimePassedModal;
